import React from "react";
import { useStoreState } from "pullstate";
import classNames from "classnames";

import { apiPath } from "shared/helpers/apiPath";
import { defaultPageItems } from "@/helpers/apiPathHelpers";
import Button from "@/components/Button";
import SkeletonLoader from "@/components/SkeletonLoader";
import PodcastTile from "@/components/FeedTiles/PodcastTile";
import feedStyles from "@/containers/Feed/Feed.module.scss";
import Typography from "@/components/Typography";
import { OtherEpisodesIntefrace } from "@/components/OtherEpisodes/OtherEpisodes.intefrace";
import { usePagination } from "@/helpers/usePagination";
import { PlayerStore } from "@/store/PlayerStore";
import styles from "src/pages/epizod/Episode.module.scss";

export const OtherEpisodes: React.FC<OtherEpisodesIntefrace> = ({
  slug,
  episodes,
}) => {
  const { listenedEpisodes } = useStoreState(PlayerStore, (store) => store);
  const {
    isEmpty,
    elements,
    isLoadingMore,
    isLoadingInitialData,
    isReachingEnd,
    loadMore,
  } = usePagination(episodes, defaultPageItems.PODCASTS, (index) =>
    apiPath.MORE_EPISODES({ slug, page: index + 1 })
  );

  return (
    <>
      {!isEmpty && (
        <Typography
          variant="h3"
          component="h3"
          className={styles.sectionHeading}
        >
          Pozostałe epizody
        </Typography>
      )}

      {elements.map((element, index) => {
        return (
          <PodcastTile
            key={index}
            {...element}
            time={listenedEpisodes?.[element?.slug]?.status}
            className={classNames(styles.podcastTile, styles.otherPodcastTile)}
          />
        );
      })}

      {isLoadingMore && <SkeletonLoader />}

      {!isReachingEnd && !isLoadingInitialData && (
        <Button
          variant="secondary"
          onClick={loadMore}
          className={feedStyles.loadMore}
        >
          Pokaż więcej
        </Button>
      )}
    </>
  );
};

export default OtherEpisodes;
